import { AdminRoutes } from "config/routes";
import { AuthGuidePage } from "./AuthGuidePage";
import { loginCodeGuideMarkdown } from "./content/loginCodeGuide";

export const LoginCodeGuide = () => (
  <AuthGuidePage
    markdown={loginCodeGuideMarkdown}
    actionPath={AdminRoutes.LoginCode}
    actionLabel="Go to Send A Login Code"
  />
);
